'use client';

import React, { useEffect, useState } from 'react';
import { Box, Paper, Fade, Button, CircularProgress, Backdrop } from '@mui/material';
import SavedQuantitiesGrid from '../../components/Estimator/SavedQuantitiesGrid';
import PipeSpecsGrid from '../../components/Estimator/PipeSpecsGrid';
import CostAssumptionsGrid from './CostAssumptions';
import StandardWallThicknessGrid from './StandardWallThicknessGrid';
import SpecialItemsGrid from './SpecialItemsGrid';
import CostCategorySummaryGrid from './CostCategorySummary';
import SurveyTitleRow from './CostCategorySummary/SurveyTitleRow';
import Materials from './CostCategorySummary/Materials';
import Construction from './CostCategorySummary/Construction';
import ProjectManagement from './CostCategorySummary/ProjectManagement';
import { useEstimator } from '../../context/EstimatorContext';

const PMInputs = ({ onComplete }) => {
  const { formData, setFormData } = useEstimator();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  const handleNext = () => {
    onComplete();
  };

  return (
    <>
      <Backdrop
        open={loading}
        sx={{
          zIndex: 9999,
          color: '#fff',
          flexDirection: 'column',
        }}
      >
        <CircularProgress color="inherit" />
        <Box mt={2} fontSize="1.25rem" fontWeight="bold">
          Calculating totals...
        </Box>
      </Backdrop>

      <Fade in>
        <Box display="flex" flexDirection="column" gap={3} mt={4}>
          <Paper elevation={1} sx={sectionStyles('#223A64')}>
            <SavedQuantitiesGrid />
          </Paper>

          <Paper elevation={3} sx={sectionStyles('#A7B9D1')}>
            <CostAssumptionsGrid />
          </Paper>

          <Paper elevation={3} sx={sectionStyles('#5A7AA1')}>
            <StandardWallThicknessGrid />
          </Paper>

          <Paper elevation={3} sx={sectionStyles('#0C1D3C')}>
            <PipeSpecsGrid />
          </Paper>

          <Paper elevation={3} sx={sectionStyles('#8CA3C4')}>
            <SpecialItemsGrid />
          </Paper>

          <Paper elevation={3} sx={sectionStyles('#3A5B8A')}>
            <SurveyTitleRow />
          </Paper>

          <Paper elevation={3} sx={sectionStyles('#3A5B8A')}>
            <Materials />
          </Paper>

          <Paper elevation={3} sx={sectionStyles('#3A5B8A')}>
            <Construction />
          </Paper>

          <Paper elevation={3} sx={sectionStyles('#3A5B8A')}>
            <ProjectManagement />
          </Paper>

          <Box display="flex" justifyContent="flex-end">
            <Button variant="contained" color="primary" onClick={handleNext}>
              Next
            </Button>
          </Box>
        </Box>
      </Fade>
    </>
  );
};

const sectionStyles = (borderColor) => ({
  p: 3,
  backgroundColor: '#F9F9F9',
  borderRadius: 2,
  borderLeft: `4px solid ${borderColor}`,
});

export default PMInputs;
